import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";

import DesktopContactUs from "./DesktopContactUs";
import MobileContactUs from "./MobileContactUs";

@inject("CommonStore")
@observer
class ContactUs extends Component {
  render() {
    const { isDesktop } = this.props.CommonStore;

    if (!isDesktop) {
      return <MobileContactUs.component />;
    }
    return <DesktopContactUs.component />;
  }
}

export { default as ContactUsForm } from "./ContactUsForm";
export { default as ContactUsMessage } from "./ContactUsMessage";
export { default as ContactUsSubjectInput } from "./ContactUsSubjectInput";
export { default as DesktopContactUs } from "./DesktopContactUs";
export { default as EmailInput } from "./EmailInput";
export { default as MobileContactUs } from "./MobileContactUs";
export { default as UserNameInput } from "./UserNameInput";

ContactUs.wrappedComponent.propTypes = {
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("CommonStore")(observer(component));

export const ProjectComponent = {
  getFinalComponent,
  wrapper: ContactUs.wrappedComponent,
  component: ContactUs,
};

export default ProjectComponent.component;
